import request from "../utils/request";


export function login(userName: string, password: string) {
    return request({
        url: '/auth/login',
        method: 'get',
        params: {
            userName, password
        }
    })
}

export function getUserInfo() {
    return request.get<BaseResponse<{
        user: SysUser,
        resources: Array<SysResource>
    }>>('/user/info')
}

export function activateUser(values: any) {
    return request.post('/user/activate', values)
}

export function changePassword(values: any) {
    return request.post('/user/password/change', values)
}